import { render, staticRenderFns } from "./ChartTemp3.vue?vue&type=template&id=22cae9b8&scoped=true&"
import script from "./ChartTemp3.vue?vue&type=script&lang=js&"
export * from "./ChartTemp3.vue?vue&type=script&lang=js&"
import style0 from "./ChartTemp3.vue?vue&type=style&index=0&id=22cae9b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cae9b8",
  null
  
)

export default component.exports